// extracted by css-extract-rspack-plugin
export default {"popoverPaper":"RelationsPopover_popoverPaper__C3KyT","header":"RelationsPopover_header__nYZDV","backdrop":"RelationsPopover_backdrop__kfKt4"};